import IAuthUserRepository from 'domain/interfaces/repositories/IAuthUserRepository'
import { FirstChangePasswordAuthUserCommandRequest } from 'domain/entities/authUser'

export const firstChangePasswordAuthUserCommand = (
  repository: IAuthUserRepository,
  data: FirstChangePasswordAuthUserCommandRequest,
) => {
  return repository.firstChangePassword(data)
}
